import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()

    return {
        flex: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        },
        flexGp2: {
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
        },
        containerIcon: {
            color: colors.color13,
            display: 'flex',
            gap: '4px'
        },
        text: {
            color: colors.color33
        }
    }
}

export { useStyles }
